import type { CanvasRenderingContext2D } from "canvas";
import { createCanvas } from "canvas";

function createCanvasContext2d(
	width: number,
	height: number,
): CanvasRenderingContext2D {
	return createCanvas(width, height).getContext("2d", {
		alpha: false,
		// Deliberately NOT setting willReadFrequently. It's a no-op in Node
		// (node-canvas/Cairo is already CPU-backed), but this helper is also bundled
		// into frontend apps, and on Android Chrome a willReadFrequently:true canvas
		// falls onto a software path whose getImageData returns all-black tiles -
		// breaking the brick sprite readback (black canvas). See render-runner.ts.
		// willReadFrequently: false
	});
}

export default createCanvasContext2d;
